import "./style.scss";
import React from "react";
import SettingButton from "./SettingButton";
import Toggle from "react-toggle";
import { inject, observer } from "mobx-react";
import { injectIntl } from "react-intl";
import { Row, Col } from "react-bootstrap";

@injectIntl
@inject("membersStore", "rootStore")
@observer
export default class MembersCofounder extends React.Component {
  render() {
    let { membersStore, member, items } = this.props;
    let { confirm } = membersStore;
    let { roles } = this.props.rootStore;
    return (
      <Row>
        <Col sm={6}>
          <div className="toggle-container">
            {roles.includes("ceo") ? (
              <div>
                <label>
                  <h5>
                    {this.props.intl.formatMessage({ id: "ceo" })}&nbsp;&nbsp;
                  </h5>
                </label>
                <Toggle
                  checked={false}
                  onChange={e => {
                    if (confirm()) membersStore.handleRole(member.id, "ceo");
                  }}
                />
              </div>
            ) : null}
          </div>
          {items === "bRoles" &&
          membersStore.getBoard(member.id).includes('board_of_director') ? (
            <div className="toggle-container">
              {membersStore.canManage || member.subdirector ? (
                <label>
                  <h5>
                    {this.props.intl.formatMessage({ id: "director" })}
                    &nbsp;&nbsp;
                  </h5>
                </label>
              ) : null}
              {!membersStore.canManage ? null : (
                <Toggle
                  checked={member.subdirector}
                  onChange={e => {
                    if (confirm())
                      membersStore.handleDirector(
                        member.id,
                        !member.subdirector
                      );
                  }}
                />
              )}
            </div>
          ) : null}
        </Col>
        <Col sm={6}>
          <div className="role-container">
            <h5>{this.props.intl.formatMessage({ id: "responsability" })}: </h5>
            <h5>{this.props.intl.formatMessage({ id: member.scorecard })}</h5>
            &nbsp;&nbsp;
            <div id="setting-button-container">
              {!membersStore.canManage ? null : (
                <SettingButton
                  options="responsibilities"
                  member={this.props.member}
                  handle={membersStore.handleResponsibility}
                />
              )}
            </div>
          </div>
          <div className="role-container">
            <h5>{this.props.intl.formatMessage({ id: "board" })}: </h5>
            <h5>
              {membersStore.getBoard(member.id).map(
                elem =>
                  `${this.props.intl.formatMessage({
                    id: elem
                  })}, `
              )}
            </h5>
            &nbsp;&nbsp;
            {!membersStore.canManage ? null : (
              <div id="setting-button-container">
                <SettingButton
                  options="bRoles"
                  member={member}
                  handle={membersStore.handleBoard}
                />
              </div>
            )}
          </div>
        </Col>
      </Row>
    );
  }
}
